import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicCloudImageListParamsRawI,
	type LWApiPublicCloudImageListResultRawI,
} from '@liquidweb-dev/club-sauce/public/cloud/image/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

const sortImages = (data: LWApiPublicCloudImageListResultRawI) => ({
	...data,
	items: [...data.items].sort(
		({ time_taken: a }, { time_taken: b }) =>
			new Date(b).getTime() - new Date(a).getTime(),
	),
});

export const CLOUD_IMAGE_LIST_QUERY_KEY = '/cloud/image/list';

const useCloudImageList = (
	params: LWApiPublicCloudImageListParamsRawI,
	options?: UseQueryOptions<LWApiPublicCloudImageListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [CLOUD_IMAGE_LIST_QUERY_KEY, params],
		queryFn: () => api.cloud.image.apiRaw.list(params),
		select: sortImages,
		...options,
	});

export const useAllCloudImages = (
	params: LWApiPublicCloudImageListParamsRawI,
	options?: UseQueryOptions<LWApiPublicCloudImageListResultRawI, ApiErrorI>,
) => {
	return useCloudImageList({ ...params, page_size: 9999 }, options);
};

export default useCloudImageList;
